
import React from "react";

interface StudentInfoProps {
  fullName: string;
  nickname?: string;
  gradeLevel: string;
}

export const StudentInfo: React.FC<StudentInfoProps> = ({
  fullName,
  nickname,
  gradeLevel
}) => {
  return (
    <>
      <td>
        {fullName} {nickname && `(${nickname})`}
      </td>
      <td>{gradeLevel || "-"}</td>
    </>
  );
};
